import React, { Fragment, useEffect, useState } from "react";
import DataTable from "../../../Common/Components/DataTable";
import { GetData, DeleteData } from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router";

function List() {
  const initialState = {
    loading: false,
    data: {
      data: null,
      current_page: null,
    },
    modal: false,
  };
  const navigate = useNavigate();
  const [state, setstate] = useState(initialState);
  useEffect(() => {
    Handler();
  }, []);
  const Handler = (pageNumber = 1, limit, index) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, limit, index).then(result => {
      setstate({
        loading: false,
        data: result.blogs_list,
      });
    });
  };

  const HandlerDelete = data => {
    setstate({ ...state, loading: true });
    DeleteData(data);
    GetData().then(result => {
      Handler();
    });
  };
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست مقالات</title>
      </Helmet>

      <DataTable
        heads={[
          {
            title: "عنوان",
            key: "title",
          },
          {
            title: "توضیحات",
            key: "description",
          },
          {
            title: "تاریخ انتشار",
            key: "created_at",
            type: "date",
            timetype: "date-time",
          },
          {
            title: "اخرین بروز رسانی",
            key: "updated_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        loading={state.loading}
        textEmpty="مقاله ای  ثبت نشده"
        list={state.data.data}
        data={state.data}
        function={Handler}
        currentPage={state.data && state.data.current_page}
        header=" لیست مقالات"
        textbtn="ایجاد مقاله"
        linkbtn="/Admin/blog/crate"
        links={[
          {
            function: selected => {
              HandlerDelete({ blog_id: selected });
            },
            color: "danger",
            size: "col-md-2",
            html: "حذف",
            multi: true,
            type: "delete",
          },
          {
            function: selected => {
              let slug = state.data.data.filter(
                blog => blog.id === selected[0]
              )[0].slug;
              navigate({
                pathname: `/Admin/blog/edit/${slug}`,
              });
            },
            color: "info",
            type: "key",
            size: "col-md-2",
            html: "ویرایش",
            type: "edit",
            main: true,
          },
        ]}
      />
    </Fragment>
  );
}

export default List;
